import * as React from "react"

function Phone(props) {
  return (
    <svg
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <circle
        cx={203.698}
        cy={125.424}
        r={70.298}
        fill="#e5eeff"
        transform="matrix(.34987 0 0 .34987 -46.673 -19.287)"
      />
      <path
        d="M40.16 29.723l-8.106-3.04c-.365-.122-.81-.04-1.054.243l-2.432 2.432a35.6 35.6 0 01-8.715-8.715l2.432-2.432c.284-.283.365-.689.243-1.053l-3.04-8.107a1.033 1.033 0 00-.972-.69h-.568a9.413 9.413 0 00-6.688 2.757c-1.865 1.865-2.878 4.378-2.878 7.012 0 1.743.446 3.486 1.338 4.986a45.717 45.717 0 0016.335 16.335c1.5.892 3.243 1.338 4.986 1.338 2.634 0 5.147-1.013 7.012-2.918 1.784-1.784 2.756-4.135 2.756-6.689v-.527c0-.405-.243-.81-.648-.932zm-3.526 6.729a7.848 7.848 0 01-5.593 2.31 8.089 8.089 0 01-3.973-1.054 43.623 43.623 0 01-15.605-15.605 7.976 7.976 0 01-1.054-3.973c0-2.107.81-4.094 2.31-5.553 1.378-1.378 3.162-2.148 5.107-2.148l2.554 6.85-2.594 2.594c-.324.325-.405.892-.122 1.297a37.485 37.485 0 0010.418 10.418c.405.283.932.202 1.297-.122l2.594-2.594 6.81 2.473c-.04 1.945-.811 3.729-2.149 5.107z"
        fill="#052879"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default Phone
